import React from 'react';
import { Box, Typography } from '@mui/material';

const card = {
    background: 'linear-gradient(180deg, rgba(0,120,255,0.12) 0%, rgba(1,1,52,0.4) 100%)',
    border: '1px solid rgba(0,215,255,0.28)',
    borderRadius: '22px',
    p: 2.5,
};

function Stat({ label, value }) {
    return (
        <Box>
            <Typography sx={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.6px', color: 'var(--ecal-lightgrey)', mb: 0.5 }}>
                {label}
            </Typography>
            <Typography sx={{ fontSize: '24px', fontWeight: 600, color: 'var(--ecal-white)', lineHeight: 1.2 }}>
                {value ?? '—'}
            </Typography>
        </Box>
    );
}

function KeyInsightDetails({ eventsThisMonth = 0, timeBooked = '0m', percentOfMonth = 0 }) {
    return (
        <Box sx={card}>
            <Typography sx={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '2.16px', color: 'var(--ecal-lightblue)', mb: 1.5 }}>
                Key Insight · Schedule Density
            </Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1.5 }}>
                <Stat label="Events this month" value={eventsThisMonth} />
                <Stat label="Time booked" value={timeBooked} />
                <Stat label="% of your month" value={`${percentOfMonth}%`} />
            </Box>
            <Box sx={{ height: 8, borderRadius: '999px', background: 'rgba(255,255,255,0.05)', overflow: 'hidden', mt: 2 }}>
                <Box sx={{ height: '100%', width: `${Math.min(percentOfMonth * 4, 100)}%`, background: 'linear-gradient(90deg, #00D456, #00D7FF, #0078FF)', borderRadius: '999px', transition: 'width 0.6s ease' }} />
            </Box>
            <Typography sx={{ fontSize: '12px', color: 'var(--ecal-lightgrey)', mt: 1 }}>
                Resets on the 1st of each month.
            </Typography>
        </Box>
    );
}

export default KeyInsightDetails;
